import React, { useState, useMemo, useEffect } from 'react';
import { getAllPermissoes, getAllPermissoesByModuloId, Permissoes, postAssociarPermissaoComModuloPerfilPermissao, TipoModuloModuloPerfilAcessoPermissaoResult, TipoModuloPerfilPermissao } from '@app/api/moduloPerfilPermissao';
import { Col, Form, FormInput, FormResetButton, Row, Table } from '@digital/ui';
import { Modal, Button, Icon } from 'antd';
import { compareText } from '@app/helpers/comparators';

interface ModalPermissoesProps {
    tipoModuloId: string,
    moduloId: string,
    atualizarTabelaPermissoes(): void;
}

const ModalPermissoes = (props: ModalPermissoesProps) => {

    const { tipoModuloId, moduloId, atualizarTabelaPermissoes } = props;
    const [allPermissoes, setPermissoes] = useState<Permissoes[]>();
    const [visible, setVisible] = useState<boolean>(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>();
    const [itensSelecionados, setItensSelecionados] = useState<string[]>();

    useEffect(() => {
        if (visible === true) {
            getAllPermissoesByModuloId(moduloId).then((data) => { data ? setPermissoes(data) : setPermissoes([]) });
            setSelectedRowKeys([])
        }

    }, [visible]);

    const vincularPermissoesComModulo = () => {
    
        let tipoModuloModuloPerfilAcessoPermissao: TipoModuloModuloPerfilAcessoPermissaoResult[] = []

        if (itensSelecionados && itensSelecionados.length > 0) {
            itensSelecionados.map((permissaoId) => { tipoModuloModuloPerfilAcessoPermissao.push({ permissaoId: permissaoId, tipoModuloModuloPerfilAcessoId: tipoModuloId } as TipoModuloModuloPerfilAcessoPermissaoResult) });
            postAssociarPermissaoComModuloPerfilPermissao(tipoModuloModuloPerfilAcessoPermissao).then(() => {
                atualizarTabelaPermissoes();
            });
        }
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRows: any[]) => {
            setSelectedRowKeys(selectedRows)
            if (selectedRows) {
                const permissoesIds: string[] = [];
                if (selectedRows.length > 0) {
                    selectedRows.map((id) => {
                        permissoesIds.push(id);
                    })
                }
                setItensSelecionados(permissoesIds);
            }
        },
        getCheckboxProps: (record: { name: any; }) => ({
            disabled: record.name === 'Disabled User',
            name: record.name,
        }),
        type: 'checkbox',


    };

    const showModalOrHide = () => {
        setVisible(!visible);
        setSelectedRowKeys([])

    }

    return (

        <>

            <div>
                <Button type="primary" onClick={showModalOrHide}>
                    Adcionar
                </Button>
                <Modal
                    visible={visible}
                    width={1024}
                    title="Permissoes"
                    onOk={() => { }}
                    onCancel={showModalOrHide}
                    footer={[
                        <Button key="back"
                            onClick={showModalOrHide}>
                            Fechar
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            onClick={() => {
                                vincularPermissoesComModulo();
                            }}>
                            Salvar
                        </Button>,
                    ]}
                >
                    <Table
                        dataSource={allPermissoes}
                        rowSelection={{ ...rowSelection }}
                        columns={[
                            {
                                title: 'N',
                                dataIndex: 'index',
                                width: '2%'
                            },
                            {
                                title: 'Descrição',
                                dataIndex: 'nome',
                                sorter: (a, b) => compareText(a.nome, b.nome),
                                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                                    <Form>
                                        <Row>
                                            <FormInput
                                                placeholder="Pesquisar"
                                                name="nome"
                                                style={{ marginTop: '15px' }}
                                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                                onPressEnter={() => {
                                                    if (typeof confirm === 'function') confirm();
                                                }}
                                            />
                                        </Row>
                                        <Row>
                                            <Col span={6}>
                                                <Button
                                                    type="primary"
                                                    style={{ marginLeft: '5px' }}
                                                    onClick={() => {
                                                        if (typeof confirm === 'function') confirm();
                                                    }}
                                                    icon="commons-search"
                                                    size="small">
                                                    Pesquisar
                                                </Button>
                                            </Col>
                                            <Col span={6}>
                                                <FormResetButton
                                                    size="small"
                                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                                    beforeReset={() => {
                                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                                    }}>
                                                    Limpar
                                                </FormResetButton>
                                            </Col>
                                        </Row>
                                    </Form>
                                ),
                                filterIcon: filtered => {
                                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                                },
                                onFilter: (value, record) =>
                                    record.nome !== undefined &&
                                    record.nome
                                        .toString()
                                        .toLowerCase()
                                        .includes(value.toLowerCase()),
                            },

                            {
                                title: 'Codigo',
                                dataIndex: 'codigo',
                                sorter: (a, b) => compareText(a.codigo, b.codigo),
                                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                                    <Form>
                                        <Row>
                                            <FormInput
                                                placeholder="Pesquisar"
                                                name="codigo"
                                                style={{ marginTop: '15px' }}
                                                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                                onPressEnter={() => {
                                                    if (typeof confirm === 'function') confirm();
                                                }}
                                            />
                                        </Row>
                                        <Row>
                                            <Col span={6}>
                                                <Button
                                                    type="primary"
                                                    style={{ marginLeft: '5px' }}
                                                    onClick={() => {
                                                        if (typeof confirm === 'function') confirm();
                                                    }}
                                                    icon="commons-search"
                                                    size="small">
                                                    Pesquisar
                                                </Button>
                                            </Col>
                                            <Col span={6}>
                                                <FormResetButton
                                                    size="small"
                                                    style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                                    beforeReset={() => {
                                                        if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                                    }}>
                                                    Limpar
                                                </FormResetButton>
                                            </Col>
                                        </Row>
                                    </Form>
                                ),
                                filterIcon: filtered => {
                                    const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                                    return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                                },
                                onFilter: (value, record) =>
                                    record.codigo !== undefined &&
                                    record.codigo
                                        .toString()
                                        .toLowerCase()
                                        .includes(value.toLowerCase()),

                            }
                        ]}

                    />
                </Modal>
            </div>



        </>
    )

}

export default ModalPermissoes;